<template>
  <div>
    <div class="food-item" v-for="(food,index2) in foodArr" :key="index2">
      <div class="food-img" @click="goDetail(food.goodsId)">
        <img :src="food.goodsImage" alt="" onTouchStart.prevent="preventDefaultListener"
             onContextMenu.prevent="preventDefaultListener"
             onDragStart.prevent="preventDefaultListener">
      </div>
      <div class="food">
        <div class="info" @click="goDetail(food.goodsId)">
          <span class="oneClampEllipsis">{{ food.goodsName }}</span>
          <span class="twoClampEllipsis">{{ food.goodsRemark }}</span>
        </div>
        <div class="sum">
          <div class="price">
            <span>￥</span>
            <span>{{ food.goodsPrice }}</span>
          </div>
          <div class="specs">
            <button @click="openSpecs(food.goodsId)" v-if="food.userAttr">选规格</button>
            <div class="toggle-number" v-else>
              <img src="../assets/images/menu/sub.png" alt="" class="sub" @click="addFood(0,food.goodsId,food.skuId)"
                   v-if="food.num">
              <div class="count" v-if="food.num">{{ food.num }}</div>
              <img src="../assets/images/menu/add.png" alt="" class="add" @click="addFood(1,food.goodsId,food.skuId)">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "singleFood",
  data() {
    return {
      num: []
    }
  },
  props: {
    //商品数组
    foodArr: {
      type: Array,
      default: []
    },
    mealId: {
      type: Number
    },
    func: {
      type: Function
    },
    bedName: {
      type: String
    }
  },
  created() {
    this.foodArr.map(() => {
      this.num.push(0);
    })
  },
  methods: {
    goDetail(id) {
      this.$router.push({path: "/food/details", query: {id: id, bedName: this.bedName}})
    },
    openSpecs(id) {
      this.$emit('showSpecs', id)
    },
    addFood(isAdd, goodsId, skuId) {
      const data = {
        mealId: this.mealId,
        goodsId,
        isAdd,
        skuId: 0
      }
      if (skuId) {
        data.skuId = skuId;
      }
      this.func(data)
    }
  }
}
</script>

<style scoped lang="less">
.food-item {
  margin-bottom: 20px;
  margin-left: 10px;
  display: flex;

  .food-img {
    width: 90px;
    height: 90px;
    border-radius: 4px;
    overflow: hidden;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .food {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 10px;

    .info {
      width: 100%;
      display: flex;
      flex-direction: column;

      span:nth-child(1) {
        width: 100%;
        font-size: 15px;
        font-weight: bold;
        margin-top: 3px;
      }

      span:nth-child(2) {
        font-size: 12px;
        color: #999999;
        margin-top: 10px;
      }
    }

    .sum {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;

      .price {
        color: #FC3912;
        font-weight: bold;

        span:nth-child(2) {
          font-size: 20px;
        }
      }

      .specs {
        button {
          padding: 0 5px;
          height: 22px;
          background: #126AFC;
          border-radius: 11px;
          border: none;
          color: #FFFFFF;
          font-size: 12px;
          font-weight: bold;
        }

        .toggle-number {
          display: flex;
          align-items: center;

          .sub {
            width: 20px;
            height: 20px;
          }

          .count {
            font-size: 15px;
            font-weight: bold;
            margin: 0 12px;
          }

          .add {
            width: 20px;
            height: 20px;
          }
        }
      }
    }
  }
}
</style>